﻿$.fn.dxCtrlStepper = function custom_dxCtrlStepper(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlstepper dx-ctrl");
        this.createInstance(new cdxCtrlStepper(this, option));
    }
    return this;
}

window.cdxCtrlStepper = function (container, option) {
    var Me = this;
    if (typeof option.value == 'undefined') option.value = null;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return dx.option(name);
        }
        else {
            dx.option(name, value);
        }
    }

    function mConstruit() {
        container.css("height",container.innerHeight() + "px")
        container.empty();
        container.css("padding", "5px")
        var $Table = $("<table style='width:100%'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        $("<td style='width:50%'/>").appendTo($Tr)
        option.dataSource.forEach(function (value, idx) {
            var $Td = $("<td style='width:1px'/>").appendTo($Tr)
            var dxStepBt = $("<div/>").appendTo($Td).dxCtrlStepperBt({
                value:value,
                onClick: function (value) {
                    if (option.onClick) option.onClick(value)
                }
            }).dxCtrlStepperBt("instance")
        })
        $("<td style='width:50%'/>").appendTo($Tr)

        container.css("height", "")
    }

    this.mReload = function (dataSource) {
        option.dataSource = dataSource
        mConstruit()
    }

    this.element = function () { return container; }
    this.component = function () { return dx }

    mConstruit();
}